import React from 'react';
import { Grid } from '@carbon/react';

const Footer = () => {
  return (
    <footer className="Footer">
      <Grid className="Footer-container">
        <nav className="Footer-nav">
          <a className="footer-labels" href={"https://webportal.ap-ibm.net/"} target="_blank" rel="noreferrer">Home</a>
          <a className="footer-labels" href={"https://ibminv.zendesk.com/hc/en-us"} target="_blank" rel="noreferrer">Contact</a>
          <a className="footer-labels" href={"https://www.ibm.com/us-en/privacy"} target="_blank" rel="noreferrer">Privacy</a>
          <a className="footer-labels" href={"https://www.ibm.com/legal"} target="_blank" rel="noreferrer">Terms of use</a>
          <a className="footer-labels" href={"https://www.ibm.com/able/"} target="_blank" rel="noreferrer">Accessibility</a>
          <a className="footer-labels" href={"https://w3.ibm.com/w3publisher/ap-web-portal-system"} target="_blank" rel="noreferrer">More Information</a>
        </nav>
      </Grid>
    </footer>
  );
}


export default Footer;